// React Imports
import * as React from "react";
import {useDispatch, useSelector} from "react-redux";
import {useState, useEffect} from "react";


// Mui Imports
import {
    deepOrange,
} from '@mui/material/colors';
import Box from "@mui/material/Box";
import {CircularProgress} from "@mui/material";
import {DataGridPro, GRID_DETAIL_PANEL_TOGGLE_FIELD} from "@mui/x-data-grid-pro";

// App Imports
import {getCalcHierarchyAddOn, getCalcHierarchyBase} from "../../ContractDataPointValue/ContractDataPointValueClient";
import {changeObligationHierarchy} from "./obligationHierarchySlice";
import WorkIssuanceObligationFinancialGrid from "./DetailDrawers/WorkIssuanceObligationFinancialGrid";
import {changeContractDrilldownExpandCS} from "../../ContractDrilldown/contractDrilldownSliceExpandCS";
import {WorkIssuanceObligationGridColumns} from "./WorkIssuanceObligationGridColumns";
import {changeWorkIssuance} from "../workIssuanceSlice";
import {getContractHeaderStandard} from "../../Contract/ContractClient";
import LinearIndeterminate from "../../CommonComponents/Progress";


// main function
export default function WorkIssuanceObligationGrid(props) {

    // ****************** BEGIN STATES ****************************

    const [contracts, setContracts] = useState([]);
    const [retrievedRows, setRetrievedRows] = useState([0]);
    const [progressSpinner, setProgressSpinner] = React.useState(false);
    const [openFinancialDrawer, setOpenFinancialDrawer] = useState(false);

    const [submitting, setSubmitting] = useState(false);

    // ****************** END STATES ****************************


    // *********************** BEGIN STORE ********************************

    const selectorContractId = useSelector((state) => state.workQueueSlc.value.selectedContractId);
    const selectorProductId = useSelector((state) => state.workIssuanceSlc.value.fetchProductId);
    const selectorCdpId = useSelector((state) => state.obligationHierarchySlc.value.addOnCdpId);
    const selectorHierarchyLevel = useSelector((state) => state.obligationHierarchySlc.value.addOnHierarchyLevel);
    const [selectorMaxId, setSelectorMaxId] = React.useState(0);
    const cashState = useSelector((state) => state.workIssuanceSlc.value.cashState)
    const accrualState = useSelector((state) => state.workIssuanceSlc.value.accrualState)
    const liabilityState = useSelector((state) => state.workIssuanceSlc.value.liabilityState)
    const ultimatesState = useSelector((state) => state.workIssuanceSlc.value.ultimatesState)
    const fetchProductId = useSelector((state) => state.workIssuanceSlc.value.fetchProductId);
    const fetchVersionNumber = useSelector((state) => state.workIssuanceSlc.value.fetchVersionNumber);

    const expandCdpId = useSelector((state) => state.contractDrilldownSlcExpandCS.value.focusCdpId);

    // ********************** END STORE ********************************


    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************


    const hideActions = localStorage.getItem('hideActions') === "true";


    // ****************** BEGIN FETCH ****************************

    const fetchcontractHeaders = () => {
        if (selectorContractId > 0
        ) {
            getContractHeaderStandard(selectorContractId)

                .then(data => {
                    console.log("My header");
                    console.log(data);
                    setContractHeader(data);
                    setSelectorContractName(data[0].name);
                    setSelectorContractHeader(data[0]);
                })}};

    //
    //
    // const fetchObligations = () => {
    //     console.log("fetchObligation triggered in the obligation grid")
    //     if (fetchProductId > 0
    //     ){
    //         let calcType = null;
    //         if (cashState === true) {
    //             calcType = "Obligation";
    //         } else if (accrualState === true) {
    //             calcType = "Accrual Obligation";
    //         } else if (liabilityState === true) {
    //             calcType = "Liability Obligation";}
    //         else if (ultimatesState === true) {
    //             calcType = "Ultimate Obligation";
    //         }
    //         console.log("calcType ", calcType);
    //         setSubmitting(true);

    //             .then(data => {
    //                 console.log(data);
    //                 setContracts(data);
    //                 const ids = data
    //                     .filter(item =>
    //                         data.some(
    //                             other =>
    //                                 other.id !== item.id &&
    //                                 other.hierarchy.includes(item.hierarchy)
    //                         )
    //                     )
    //                     .map(item => item.id);
    //                 setRetrievedRows(ids);
    //                 console.log("retrieved row ids:", ids);
    //                 console.log("length of obligation data:", data.length);
    //                 const maxId = Math.max(...data.map(item => item.id));
    //                 setSelectorMaxId(maxId);
    //                 console.log("max id of obligation data:", maxId);
    //                 setSubmitting(false);
    //             })}};


    const selectorObligationGridRefresh = useSelector(
        state => state.workIssuanceSlc.value.obligationGridRefresh
    );

    const fetchObligations = React.useCallback(() => {
        console.log("fetchObligation triggered in the obligation grid");

        if (fetchProductId <= 0) return Promise.resolve();

        let calcType = null;

        if (cashState === true) {
            calcType = "Obligation";
        } else if (accrualState === true) {
            calcType = "Accrual Obligation";
        } else if (liabilityState === true) {
            calcType = "Liability Obligation";
        } else if (ultimatesState === true) {
            calcType = "Ultimate Obligation";
        }

        console.log("calcType ", calcType);

        setSubmitting(true);

        return getCalcHierarchyBase(fetchProductId, fetchVersionNumber, calcType)

            .then(data => {
                console.log(data);

                setContracts(data);

                const ids = data
                    .filter(item =>
                        data.some(
                            other =>
                                other.rowId !== item.rowId &&
                                other.hierarchy.includes(item.hierarchy)
                        )
                    )
                    .map(item => item.rowId);

                setRetrievedRows(ids);
                console.log("retrieved row ids:", ids);
                console.log("length of obligation data:", data.length);

                const maxId = Math.max(...data.map(item => item.rowId));
                setSelectorMaxId(maxId);
                console.log("max id of obligation data:", maxId);
            })
            .finally(() => {
                setSubmitting(false);
            });
    }, [
        fetchProductId,
        fetchVersionNumber,
        cashState,
        accrualState,
        liabilityState,
        ultimatesState
    ]);

    useEffect(() => {
        if (!selectorObligationGridRefresh) return;

        console.log("obligations fetch triggered by grid refresh = true");

        fetchObligations().finally(() => {
            dispatchData(changeWorkIssuance({
                obligationGridRefresh: false
            }));
        });
    }, [selectorObligationGridRefresh, fetchObligations, dispatchData]);
    //
    // useEffect(() => {
    //     console.log("obligations fetch triggered by grid refresh = true");
    //     fetchObligations();
    //     dispatchData(changeWorkIssuance({obligationGridRefresh: false}));
    // }, [useSelector((state) => state.workIssuanceSlc.value.obligationGridRefresh)===true]);


    const fetchMoreObligations = (rowData) => {
        if (rowData.rowId && !retrievedRows.includes(rowData.rowId)) {
            setProgressSpinner(true);
            setRetrievedRows((retrievedRows) => [...retrievedRows, rowData.rowId]);
            console.log("fetching more obligations");
            console.log("selectorCdpId: ", selectorCdpId);
            console.log("selectorHierarchy: ", selectorHierarchyLevel);
            console.log("selectorHierarchyLevel: ", selectorHierarchyLevel);
            console.log("selectorMaxId: ", selectorMaxId);
            getCalcHierarchyAddOn(rowData.cdpId, rowData.hierarchy, rowData.hierarchyLevel, selectorMaxId, "Obligation")

                .then(data => {
                    console.log(data);
                    const ids = data.map(row => row.rowId);
                    setRetrievedRows((retrievedRows) => [...retrievedRows, ...ids]);
                    console.log("row ids");
                    console.log(ids);
                    setContracts((contracts) => [...contracts, ...data]);
                    console.log("length of obligation data:", data.length);
                    const maxId = Math.max(...data.map(item => item.rowId));
                    setSelectorMaxId(maxId);
                    console.log("max id of obligation data:", maxId);
                     setProgressSpinner(false);

                })}};

    // ****************** END FETCH ****************************


    // ******************** BEGIN USE EFFECTS *******************

    useEffect(() => {
        console.log("Loading Contracts Header");
        fetchcontractHeaders()
    }, []);
    //
    //
    // useEffect(() => {
    //     console.log("Loading the contract grid...");
    //     fetchObligations();
    // }, []);


    useEffect(() => {
        setContracts([]);
        dispatchData(changeWorkIssuance({clearData: false}));
    }, [useSelector((state) => state.workIssuanceSlc.value.clearData)===true]);

    // ******************** END USE EFFECTS *******************


    // ***************** BEGIN CONTROLS ***************************

    const handleClickedRow = (rowData) => {
        console.log("clickedRow", rowData);
        console.log("clicked id", rowData.rowId);
        console.log("clicked cdp_id", rowData.cdpId);
        console.log("clicked cdpv_id", rowData.cdpvId);
        console.log("clicked hierarchy", rowData.hierarchy);
        console.log("clicked hierarchy level", rowData.hierarchyLevel);
        dispatchData(changeObligationHierarchy({
            addOnCdpId: rowData.cdpId,
            addOnHierarchy: rowData.hierarchy,
            addOnHierarchyLevel: rowData.hierarchyLevel}));
        fetchMoreObligations(rowData);
    }

    const handleMousedRow = (rowFull) => {
    };


    const handleExploreExternalData = (selectedCDPV) => {
        console.log("Here's the row data clicking the external data button");
        console.log(selectedCDPV);
        console.log("Here's the cdpvId: ", selectedCDPV.cdpvId);
        console.log(selectedCDPV);
        dispatchData(changeObligationHierarchy({cdpvId: selectedCDPV.cdpvId
            ,  externalSource: selectedCDPV.externalSource,displayValue: selectedCDPV.displayValue,
            dataPointName: selectedCDPV.dataPointName,contractName: selectedCDPV.contractName,
            reuseMarket: selectedCDPV.reuseMarket,  dataType: selectedCDPV.dataType
        }));
        if(selectedCDPV.externalSource === 'financial')
        {        console.log("financial grid triggered")
            setOpenFinancialDrawer(true);
            dispatchData(changeObligationHierarchy({financialGridOpen: true}))};
        if(selectedCDPV.externalSource === 'usage')
        {dispatchData(changeObligationHierarchy({usageGridOpen: true}))};
        if(selectedCDPV.externalSource === 'license')
        {dispatchData(changeObligationHierarchy({licenseGridOpen: true}))};
        if(selectedCDPV.externalSource === 'platform')
        {dispatchData(changeObligationHierarchy({platformGridOpen: true}))};
        if(selectedCDPV.externalSource === 'viewership')
        {dispatchData(changeObligationHierarchy({viewershipGridOpen: true}))};
        if(selectedCDPV.externalSource === 'product')
        {dispatchData(changeObligationHierarchy({productGridOpen: true}))};
        if(selectedCDPV.externalSource === 'subscriber')
        {dispatchData(changeObligationHierarchy({subscriberGridOpen: true}))};
        if(selectedCDPV.externalSource === 'cast_list')
        {dispatchData(changeObligationHierarchy({stakeholderListGridOpen: true}))};
    };

    // *************** END CONTROLS *******************************


    // ***************************** SOURCE WINDOW ***************************************************************
    //

    // new ChatGpt version
    const openSourceWindow = (sourceRow) => {
        // 1. Build the child URL from wherever we are right now
        const childURL   = `${window.location.origin}/ResidualsFrontend`;
        const childOrigin = new URL(childURL).origin;        // no path, no trailing slash

        console.log("Opening child window at:", childURL);

        // 2. Open the window
        // const newWindow = window.open(childURL, "_blank", "noopener");
        const newWindow = window.open(childURL, "_blank");



        // 3. Local UI update
        dispatchData(changeContractDrilldownExpandCS({ focusCdpId: sourceRow.cdpId }));

        // 4. Prepare exactly your original payload
        const dataToSend = {
            type: "UPDATE_DATA",
            payload: {
                contractId:          sourceRow.sourceContractId,
                contractName:        sourceRow.sourceContractName,
                contractDescription: sourceRow.sourceContractDescription,
                contractSectionId:   sourceRow.sourceSectionId,
                contractSectionName: sourceRow.sourceSection,
                contractDataPointId: sourceRow.sourceContractDataPointId,
                parentSection1Id:    sourceRow.sourceParentSectionId1,
                parentSection2Id:    sourceRow.sourceParentSectionId2,
                parentSection3Id:    sourceRow.sourceParentSectionId3,
                parentSection4Id:    sourceRow.sourceParentSectionId4,
                parentSection5Id:    sourceRow.sourceParentSectionId5,
                parentSection6Id:    sourceRow.sourceParentSectionId6,
                parentSection7Id:    sourceRow.sourceParentSectionId7,
                parentSection8Id:    sourceRow.sourceParentSectionId8,
                parentSection9Id:    sourceRow.sourceParentSectionId9,
                parentSection10Id:   sourceRow.sourceParentSectionId10,
            },
        };

        // const sendMessage = (tag) => {
        //     console.log(">>> sendMessage()", tag, "at", Date.now());
        //     if (newWindow && !newWindow.closed) {
        //         try {
        //             newWindow.postMessage(dataToSend, childOrigin);
        //             console.log("Sent payload to child:", dataToSend);
        //         } catch (err) {
        //             console.error("postMessage failed:", err);
        //         }
        //     }
        // };
        const sendMessage = (tag) => {
            const now = new Date().toLocaleTimeString();
            console.log(`>>> sendMessage(${tag}) at ${now}`);

            if (!newWindow || newWindow.closed) {
                console.warn("newWindow closed or missing");
                return;
            }

            try {
                newWindow.postMessage(dataToSend, childOrigin);
                console.log("✓ Sent payload to child (", tag, ")");
            } catch (err) {
                console.error("✗ postMessage failed (", tag, "):", err);
            }
        };
        // a) try right away (cached fast loads)
        sendMessage("immediate");
        // console.log(">>> sendMessage() called at", Date.now());
        // b) as soon as the document is fully loaded
        // newWindow?.addEventListener("load", sendMessage, { once: true });
        if (newWindow && typeof newWindow.addEventListener === "function") {
            // `{ once: true }` is fine in all modern browsers; remove it for IE11
            newWindow.addEventListener("load", () => sendMessage("load"), { once: true });
        }
        // c) fallback after 5 s if neither of the above hit
        setTimeout(() => sendMessage("timeout"), 5000);
    };

    // const FRONTEND_URL = import.meta.env.VITE_FRONTEND_URL;
    //
    // const openSourceWindow = (sourceRow) => {
    //     // const newWindow = window.open('http://localhost:3000/ResidualsFrontend', '_blank');
    //     console.log('FRONTEND_URL:', import.meta.env.VITE_FRONTEND_URL);
    //     const newWindow = window.open(`${FRONTEND_URL}/ResidualsFrontend`, '_blank');
    //     dispatchData(changeContractDrilldownExpandCS({ focusCdpId: sourceRow.cdpId}));
    //     const dataToSend = { type: 'UPDATE_DATA', payload: { contractId: sourceRow.sourceContractId,
    //             contractName: sourceRow.sourceContractName,  contractDescription: sourceRow.sourceContractDescription,
    //             contractSectionId: sourceRow.sourceSectionId, contractSectionName: sourceRow.sourceSection,
    //             contractDataPointId: sourceRow.sourceContractDataPointId,
    //             parentSection1Id: sourceRow.sourceParentSectionId1,
    //             parentSection2Id: sourceRow.sourceParentSectionId2,
    //             parentSection3Id: sourceRow.sourceParentSectionId3,
    //             parentSection4Id: sourceRow.sourceParentSectionId4,
    //             parentSection5Id: sourceRow.sourceParentSectionId5,
    //             parentSection6Id: sourceRow.sourceParentSectionId6,
    //             parentSection7Id: sourceRow.sourceParentSectionId7,
    //             parentSection8Id: sourceRow.sourceParentSectionId8,
    //             parentSection9Id: sourceRow.sourceParentSectionId9,
    //             parentSection10Id: sourceRow.sourceParentSectionId10
    //         } };
    //     console.log('Preparing to send data:', dataToSend);
    //     console.log("Parent 1 ID;", sourceRow.sourceParentSectionId1)
    //     setTimeout(() => {
    //         if (newWindow) {
    //             console.log("new window path at message time: ", newWindow.location.pathname)
    //             newWindow.onload = () => {
    //                 newWindow.postMessage(dataToSend, `${FRONTEND_URL}`); //// Ensure this matches your new window's origin
    //                 // newWindow.postMessage(dataToSend, 'http://localhost:3000'); // Ensure this matches your new window's origin
    //                 console.log('Data successfully sent to the new window:', dataToSend);
    //             }} else {
    //             console.error('Failed to open the new window or newWindow is null.');
    //         };
    //     }, 500);
    // }

    // ******************************** END SOURCE WINDOW ************************************************



    function DetailPanelContent() {
        return (
            <h2>TEST</h2>
        )}

    const getDetailPanelHeight = React.useCallback(() => 300, []);


    const getDetailPanelContent = React.useCallback(
        ({ row }) => <DetailPanelContent row={contracts.rowId} />,
        [],
    );

    const getTreeDataPath = (contracts) => contracts.hierarchy.split(',');

    const groupingColDef = {
        hideDescendantCount: true,
        width: 450,
    };



    // ****************** BEGIN RETURN ****************************

        return (
            <Box sx={{ height:800 , width: '100%',

                '& .level--1': {backgroundColor: "rgb(30,144,255)"},//https://html-color.codes/blue dodger blue
                '& .level--2': {backgroundColor: "rgb(69,177,232)"},//https://html-color.codes/blue picton blue
                '& .level--3': {backgroundColor: "rgb(135,206,250)"},//https://html-color.codes/blue lightskyblue
                '& .level--4': {backgroundColor: "rgb(137,207,240)"},//https://html-color.codes/blue baby blue
                '& .level--5': {backgroundColor: "rgb(173,216,230)"},//https://html-color.codes/blue light blue
                '& .level--6': {backgroundColor: "rgb(135,206,235)"},//https://html-color.codes/blue skyblue
                '& .level--7': {backgroundColor: "rgb(231,254,255)"},//https://html-color.codes/blue bubbles
                '& .level--8': {backgroundColor: "rgb(244,240,236)"},//https://html-color.codes/grey isabelline
                '& .level--9': {backgroundColor: "rgb(250,250,250)"},//custom
                '& .level--10': {backgroundColor: "rgb(255,255,255)"},//custom
            }}
            >
                <div>
                    {useSelector((state) => state.obligationHierarchySlc.value.financialGridOpen) && <WorkIssuanceObligationFinancialGrid/>}
                    {openFinancialDrawer && <WorkIssuanceObligationFinancialGrid/>}
                </div>
                {submitting && <LinearIndeterminate/>}
                {progressSpinner &&
                    (
                        <Box
                            position="absolute"
                            top={0}
                            left={0}
                            width="100%"
                            height="100%"
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            bgcolor="rgba(255,255,255,0.5)" // optional dimmed overlay
                            zIndex={10}
                        >
                            <CircularProgress />
                        </Box>
                    )}
                <DataGridPro
                    experimentalFeatures={{ newEditingApi: true }}
                    sx={{
                        '& .MuiDataGrid-detailPanel': {
                            backgroundColor: deepOrange[100],
                        },
                    }}
                    initialState={{
                        sorting: {
                            sortModel: [{ field: 'hierarchyOrder', sort: 'asc' }],
                        }
                        // filter: {
                        //     items: [
                        //         {
                        //             columnField: 'id',
                        //             operatorValue: '==',
                        //             value: '30'
                        //         }]
                        // }
                    }}
                    treeData
                    aria-label={"Contracts"}
                    rows={contracts}
                    getRowClassName={(contracts) => `level--${contracts.row.hierarchyLevel}`}
                    getDetailPanelContent={({ row }) => (
                        <Box sx={{
                            p: 2, flexGrow: 1,
                            bgcolor: deepOrange[100]
                            // backgroundColor: "rgb(255,204,153)"
                        }}>
                            <Box sx={{ml: 2}}>
                                <strong>Expression:</strong> {row.expression}
                            </Box>
                            <br/>
                            <Box sx={{ml: 2}}>
                                <strong>Translation:</strong> {row.expressionTranslation}
                            </Box>
                            <br/>
                            <Box sx={{ml: 2}}>
                                <strong>Description:</strong> {row.expressionDescription}
                            </Box>
                            <br/>
                            <Box sx={{ml: 2}}>
                                <strong>Raw Expression:</strong> {row.rawExpression}
                            </Box>
                        </Box>
                    )}
                    getDetailPanelHeight={getDetailPanelHeight}
                    // getRowHeight={({ row }) => {
                    //     const lineHeight = 24;
                    //     const padding = 32;
                    //     const brSpacing = 32; // for 2 <br/><br/> lines
                    //     const lines = [
                    //         row.mockExpression,
                    //         row.mockExpressionTranslation,
                    //         row.rawExpression,
                    //     ].filter(Boolean).length;
                    //
                    //     return padding + lines * lineHeight + brSpacing + 24;
                    // }}
                    disableDensitySelector={true}
                    disableColumnSelector={true}
                    // columns={columns(fetchObligations)}
                    columns={WorkIssuanceObligationGridColumns({
                        hideActions,
                        openSourceWindow,
                        handleMousedRow,
                        contracts,
                        handleClickedRow,
                        handleExploreExternalData,
                        expandCdpId
                    })}
                    density={"compact"}
                    pageSize={20}
                    rowsPerPageOptions={[20]}
                    // rowKey={contract => contract.rowId}
                    getRowId={(row) => row.rowId}
                    getTreeDataPath={getTreeDataPath}
                    groupingColDef={groupingColDef}
                    components={{
                        // Toolbar: CustomToolbar,
                        // Footer: CustomFooter,
                    }}
                />
            </Box>

        );

    // ****************** END RETURN ****************************


}


